export default __webpack_public_path__ + "static/media/tick.e4418a99.svg";